module.exports = fox._r("components/login-wizard/images/login-denied.png", __webpack_public_path__ + "components/login-wizard/images/login-denied.png");


//////////////////
// WEBPACK FOOTER
// ./components/login-wizard/images/login-denied.png
// module id = 538
// module chunks = 2